import * as APITypes from "~/API";
import { getBuildingList } from "~/services/server";
import { buildPropertyMap } from "../helpers";
import type { EntityListData, EntityListOptions } from "~/types";

export const formatBuildingOptions = (
  buildingList: APITypes.Building[],
  propertyMap: Record<string, APITypes.Property>
): EntityListOptions[] => {
  return buildingList.map((building) => ({
    value: building.id.toString(),
    text: `Building: ${building.name.toString()} - Property: ${
      propertyMap[building.propertyID]?.name
    }`,
  }));
};

export const getBuildingEntityList = async (
  ownerID: string,
  ownerType: APITypes.OwnerType
): Promise<EntityListData> => {
  const buildingList = await getBuildingList({ ownerID, ownerType });
  const propertyMap = await buildPropertyMap(ownerID, ownerType);

  return {
    propertyList: [],
    buildingList: buildingList.data,
    unitList: [],
    serviceRequestList: [],
    amenityList: [],
    propertyMap,
    buildingMap: {},
    unitMap: {},
  };
};
